import PageShell from "../components/PageShell";

const TESTFLIGHT_URL = "https://testflight.apple.com/join/QFhW8RSn";

/** /beta — how to install the app while it's in open beta on TestFlight. */
const BetaPage = () => (
  <PageShell>
    <main className="station">
      <p className="eyebrow">
        <span className="blip" /> Open beta
      </p>
      <h1 className="station__name">Start listening today.</h1>
      <p className="station__sub">
        StreamLover is in open beta on iOS, free through Apple's TestFlight. Two
        minutes and you're on the air.
      </p>

      <ol className="station__steps">
        <li>
          <strong>Install TestFlight.</strong> On your iPhone or iPad, get{" "}
          <a href="https://apps.apple.com/app/testflight/id899247664">
            TestFlight
          </a>{" "}
          from the App Store — it's Apple's own free app for running beta apps.
        </li>
        <li>
          <strong>Accept the invite.</strong> On your phone, tap the button
          below and accept the invitation to the StreamLover beta.
        </li>
        <li>
          <strong>Install StreamLover.</strong> Tap Install in TestFlight, and
          StreamLover lands on your home screen like any other app. Updates
          arrive through TestFlight automatically.
        </li>
      </ol>

      <a className="btn btn--lg" href={TESTFLIGHT_URL}>
        Join the beta on TestFlight
      </a>

      <p className="station__quiet">Android — coming soon.</p>
    </main>
  </PageShell>
);

export default BetaPage;
